export default __webpack_public_path__ + "abe083d96b58eb02ada8b7c30d7b09f2.woff2";